import { NavLink } from 'react-router-dom';
import { Rss, Search, Activity } from 'lucide-react';

const tabs = [
  { to: '/admin/sources', label: 'Zdroje', icon: Rss },
  { to: '/admin/queries', label: 'Topic queries', icon: Search },
  { to: '/admin/runs', label: 'Daily runs', icon: Activity },
];

export default function AdminTabs() {
  return (
    <nav className="mb-6 flex gap-1 border-b border-gray-200">
      {tabs.map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) =>
            `flex items-center gap-2 border-b-2 px-4 py-2 text-sm font-medium transition-colors ${
              isActive
                ? 'border-teal text-teal'
                : 'border-transparent text-gray-500 hover:text-dark'
            }`
          }
        >
          <Icon className="h-4 w-4" />
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
